import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Box, CssBaseline } from '@mui/material';

import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Hotels from './pages/Hotels';
import About from './pages/About';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import Hoteldetails from './pages/Hoteldetails';
import CheckAvailability from './pages/CheckAvailability';
import Thankyou from './pages/Thankyou';

export default function App() {
  return (
    <>
    <Router>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: '#f8fafc' }}>
        <CssBaseline />
        <Header />
        <Box component="main" sx={{ flexGrow: 1 }}>
          <Routes>
            {/* <Route path="/" element={<Home />} /> */}
            {/* <Route path="/index" element={<Home />} /> */}
            <Route path="/check-availability" element={<CheckAvailability />} />
            <Route path="/hotel-details/:propertyId" element={<Hoteldetails />} />
            <Route path="/about" element={<About />} />
            <Route path="/about" element={<About />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/thankyou" element={<Thankyou />} />
            {/* <Route path="*" element={<Home />} /> */}
          </Routes>
        </Box>
        <Footer />
      </Box>
    </Router>
    </>

  );
}